import { Link, useNavigate } from "react-router-dom";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import toast from "react-hot-toast";
import { deleteSymptom } from "../actions";
import { Button } from "../../../../components/button";

export function CreateButton() {
  return (
   
    <Link to={"/admin/physical-and-mental-symptoms/create"} className="contents">
    <Button className="mt-4">
      Create
      <Icon icon={PlusIcon} label="Create Symptom" className="ml-1" />
      </Button>
  </Link>
  );
}

export function UpdateButton({ id }: { id: number }) {
  return (
    <Link to={`/admin/physical-and-mental-symptoms/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteButton({ id }: { id: number }) {
  const navigate = useNavigate();

  const deleteWithId = deleteSymptom.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this symptom?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      toast.success("Symptom deleted successfully");
      navigate(`/admin/physical-and-mental-symptoms?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}


